<template>
  <div
    id="login-page"
    class="row"
  >
    <non-auth-logo-block
      :title="$t('view-Login.asside.title')"
      :button-title="$t('view-Login.asside.button.sing-up')"
      add-class="order-2"
    />
    <div class="col-20 col-md-11 order-1 add-border">
      <div class="content-column text-center">
        <validation-observer
          ref="observer"
        >
          <b-form
            class="vertical-fill"
            @submit="onSubmit"
          >
            <div class="title">
              {{ $t('view-Login.title') }}
            </div>

            <div>
              <validation-provider
                v-slot="validationContext"
                :name="$t('view-Register-step2.input-name.email')"
                :rules="{ required: true, email: true, max: 255 }"
              >
                <b-form-group
                  id="input-group-email"
                  label-cols="6"
                  label-cols-lg="5"
                  :label="$t('view-Login.input.email')"
                  label-for="email-input"
                >
                  <b-form-input
                    id="email-input"
                    v-model="form.email"
                    type="email"
                    required
                    :placeholder="$t('view-Login.input.email')"
                    aria-describedby="input-email-feedback"
                    :state="getValidationState(validationContext)"
                  />
                  <b-form-invalid-feedback id="input-email-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>

              <validation-provider
                v-slot="validationContext"
                :name="$t('view-Register-step2.input-name.password')"
                :rules="{ required: true, min: 8 }"
              >
                <b-form-group
                  id="input-group-password"
                  label-cols="6"
                  label-cols-lg="5"
                  :label="$t('view-Login.input.password')"
                  label-for="password-input"
                >
                  <b-form-input
                    id="password-input"
                    v-model="form.password"
                    type="password"
                    required
                    :placeholder="$t('view-Login.input.password')"
                    :state="getValidationState(validationContext)"
                    aria-describedby="input-password-feedback"
                  />
                  <b-form-invalid-feedback id="input-password-feedback">
                    {{ validationContext.errors[0] }}
                  </b-form-invalid-feedback>
                </b-form-group>
              </validation-provider>
            </div>

            <div>
              <b-form-group id="input-group-4">
                <b-form-checkbox
                  v-model="form.remember"
                  value="1"
                >
                  {{ $t('view-Login.input.rememberme') }}
                </b-form-checkbox>
              </b-form-group>

              <div class="col-20">
                <router-link to="/password-reminder">
                  {{ $t('view-Login.forgot-password') }}
                </router-link>
              </div>
            </div>

            <div>
              <std-button
                :is-submit="true"
                :title="$t('view-Login.button.login')"
              />
            </div>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>

<script>
import NonAuthLogoBlock from '../components/NonAuthLogoBlock'

export default {
  components: {
    'non-auth-logo-block': NonAuthLogoBlock
  },
  data () {
    return {
      form: {
        email: '',
        password: '',
        remember: 0
      }
    }
  },
  computed: {

  },
  methods: {
    getValidationState ({ dirty, validated, valid = null }) {
      return dirty || validated ? valid : null
    },
    async onSubmit (e) {
      e.preventDefault()

      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      this.$store.dispatch('auth/login', { login: this.form.email, password: this.form.password, rememberMe: this.form.remember })
        .then((r) => {
          /* switch lang to user preference */
          this.$store.dispatch('user/getProfile')
            .then((profile) => {
              this.$store.commit('setLang', profile.lang)
              this.$router.push('/').catch(() => {})
            })
            .catch(() => {})
        })
        .catch((e) => {
          if (e.response.status === 422) {
            this.$flash.error(this.$t(e.response.body.errors[0]))
          } else if (e.response.status === 403) {
            this.$flash.error(this.$t(e.response.body.error))
          } else {
            this.$flash.error(this.$t('view-Login.message.incorrect-credentials'))
          }
        })
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('loading/setRouterLoading', false)

    next()
  }
}
</script>

<style scoped lang="scss">
  #login-page {
    .content-column form {
      max-height: 600px;
      min-height: 400px;
      @media only screen and (min-height: 800px) {
        height: 600px;
      }
    }
    a {
      text-decoration: underline;
      color: inherit;
    }
  }
</style>
